<div
  class="container-fluid mlp-trending-tray-container"
  [class.reversed]="reversedLayout"
  data-testid="MarketingLandingPage.trendingTrayContainer"
>
  <div class="row" [class.flex-row-reverse]="reversedLayout">
    <div class="col-24 col-md-12 text-container" [class.align-items-md-end]="reversedLayout">
      <div class="row">
        <div class="col-24">
          <h1 class="mlp-tray-title" [class.reversed-title]="reversedLayout">{{ vm.title }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-24">
          <p class="mlp-tray-description">{{ vm.description }}</p>
        </div>
      </div>
      <div class="row d-none d-md-flex">
        <ng-container *ngTemplateOutlet="trendingButton"></ng-container>
      </div>
    </div>
    <div class="col-24 col-md-12">
      <div class="row swiper-container" data-testid="MarketingLandingPage.trendingTrayImages">
        <div class="col-24">
          <swiper
            #mobileSwiper
            [slidesPerView]="3"
            [grabCursor]="true"
            [centeredSlides]="true"
            [pagination]="false"
            [loop]="true"
            [effect]="'coverflow'"
            class="d-flex d-md-none"
            [coverflowEffect]="{
              rotate: 0,
              stretch: (isMobileScreen$ | async) ? -20 : -35,
              depth: 100,
              modifier: 2,
              slideShadows: false
            }"
          >
            <ng-template *ngFor="let thumbnailUrl of vm.thumbnailImageUrls; let i = index" swiperSlide>
              <img osnSharedUseAsPicture [imgQuery]="imgQuery" class="slide" [src]="thumbnailUrl" alt="{{ vm.title }} movies and series" />
            </ng-template>
          </swiper>
          <swiper
            [dir]="swiperDirection"
            #desktopSwiper
            [slidesPerView]="4"
            [grabCursor]="true"
            [centeredSlides]="true"
            [pagination]="false"
            [loop]="true"
            [effect]="'coverflow'"
            class="desktop-swiper d-none d-md-flex"
            [coverflowEffect]="{
              rotate: 0,
              stretch: 40,
              depth: 100,
              modifier: 1,
              slideShadows: false
            }"
          >
            <ng-template *ngFor="let thumbnailUrl of vm.thumbnailImageUrls; let i = index" swiperSlide>
              <img osnSharedUseAsPicture [imgQuery]="imgQuery" class="slide" [src]="thumbnailUrl" alt="{{ vm.title }} movies and series" />
            </ng-template>
          </swiper>
        </div>
        <div class="col-24 d-none d-md-flex swipe-btn-container" [class.justify-content-md-end]="reversedLayout">
          <div class="swipe-btn" (click)="reversedLayout ? onNextButtonClick() : onPrevButtonClick()">
            <svg-icon key="left" class="icon-white"></svg-icon>
          </div>
          <div class="swipe-btn" (click)="reversedLayout ? onPrevButtonClick() : onNextButtonClick()">
            <svg-icon key="right" class="icon-white"></svg-icon>
          </div>
        </div>
      </div>
      <div class="row d-block d-md-none">
        <div class="col-24 d-flex justify-content-center">
          <ng-container *ngTemplateOutlet="trendingButton"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #trendingButton>
  <osn-shared-marketing-action-button
    *ngIf="vm.button"
    [actionButton]="vm.button"
    [buttonText]="buttonText"
    data-testid="MarketingLandingPage.mlpTrayButton"
    (measureClick)="onTrendingTrayButtonClick()"
  ></osn-shared-marketing-action-button>
</ng-template>
